<div class='full-form'>
  @if (datasetACS.loading.value) {
    <mat-progress-bar class='mt-24 mb-24' mode="indeterminate"></mat-progress-bar>
  }

  @if (formViewerService.initialized && formViewerService.formGroup) {
    <form autocomplete="off" name='form' [formGroup]="formViewerService.formGroup" class="fx-column fx-justify-start fx-items-stretch fx-lt-lg-justify-stretch fx-lt-lg-items-stretch">
      <div class="section product-reference">
        <label class="input-label section-title"><b>Quantità prodotto</b></label>
        <div class="base-textfield base-textfield-large">
          <form-input-viewer
            [formInputDefinition]='fileterFields.get("quantity")'
            [formGroup]='formViewerService.formGroup'
            [formControlKey]='formViewerService.controlKeyMap["quantity"]'
            [dataContainerService]='formViewerService.dataContainerService'
            [data]='formViewerService.record'
          ></form-input-viewer>
        </div>
      </div>
      <div class="save-button-container">
        <button [disabled]='formViewerService.formGroup.invalid && !formErrors || datasetACS.loading.value' class="gyg-button gyg-button-medium gyg-button-cta-light" (click)='onSave()'>
          <span>Salva e continua</span>
        </button>
      </div>
    </form>
  }

</div>